import { lazy } from 'react';
import { routes } from '~/constants';
import { FeatureFlag } from '~/featureFlags';
import AdditionalPaymentProcessorInfoPage from '~/pages/AdditionalPaymentProcessorInfoPage/AdditionalPaymentProcessorInfoPage';
import { NoAccessPage } from '~/pages/NoAccessPage/NoAccessPage';
import { Notification } from '~/pages/Notification/Notification';
import { NotificationActionPage } from '~/pages/NotificationAction';
import { OAuthAuthorizePage } from '~/pages/OAuthAuthorizePage';
import { RedirectPage } from '~/pages/RedirectPage';
import { ResetPasswordScreen, SetPasswordScreen, SignupScreen } from '~/pages/unAuthorizedPages';
import { bootRouteChunkNames, DEFAULT_HOME_CONTENT_CHUNK, HOME_SHELL_CHUNK, ROUTE_CHUNK_ENTRIES, routeChunkNameFor } from '../../shared/route-chunk-map';
const importClientOnboarding = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/client-flow/clientOb/ClientOnboarding');
const importAllSetPage = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/client-flow/clientOb/AllSetStep/AllSetPage');
const importNoPermissionsRelationshipApproved = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/client-flow/clientOb/AllSetStep/noPermissionsRelationshipApproved');
const importRelationshipApprovedWithAnimations = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/client-flow/clientOb/RelationshipSignedStep/RelationshipApprovedWithAnimations');
const importCanceledProposalPage = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/components/CanceledProposalPage/CanceledProposalPage');
const importExpiredProposalPage = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/components/ExpiredProposalPage/ExpiredProposalPage');
const importBankVerification = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/pages/AdHocInvoiceApproval/BankVerification/BankVerification').then((m)=>({
            default: m.BankVerification
        }));
const importAgreementStudioPage = ()=>import(/* webpackChunkName: "agreement-studio" */ '~/components/AgreementStudioPage/AgreementStudioPage');
const importAgreementStudioTemplates = ()=>import(/* webpackChunkName: "agreement-studio" */ '~/components/AgreementStudioPage/AgreementStudioTemplateMode/AgreementStudioTemplates');
const importEditAgreementPage = ()=>import(/* webpackChunkName: "agreement-studio" */ '~/components/EditAgreementModal/EditAgreementPage').then((m)=>({
            default: m.EditAgreementPage
        }));
const importProposalTemplateLoader = ()=>import(/* webpackChunkName: "agreement-studio" */ '~/pages/ProposalTemplates/ProposalTemplateLoader');
const importAgreementMinisite = ()=>import(/* webpackChunkName: "agreement-minisite" */ '~/pages/AgreementMinisite/AgreementMinisite');
const importVendorOnboardingPage = ()=>import(/* webpackChunkName: "vendor-onboarding" */ '~/pages/VendorOnboarding/VendorOnboardingPage').then((m)=>({
            default: m.VendorOnboardingPage
        }));
const importVendorDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/VendorDashboard/VendorDashboard').then((m)=>({
            default: m.VendorDashboard
        }));
const importAgreementsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/AgreementsDashboard/AgreementsDashboard').then((m)=>({
            default: m.AgreementsDashboard
        }));
const importProposalsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ProposalsDashboard').then((m)=>({
            default: m.ProposalsDashboard
        }));
const importDraftsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/DraftsDashboard').then((m)=>({
            default: m.DraftsDashboard
        }));
const importArchivedProposalsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ArchivedProposalsDashboard/ArchivedProposalsDashboard').then((m)=>({
            default: m.ArchivedProposalsDashboard
        }));
const importInvoicesDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/InvoicesDashboard/InvoicesDashboard');
const importPayoutsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/PayoutsDashboard/PayoutsDashboard');
const importContactsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ContactsDashboard').then((m)=>({
            default: m.ContactsDashboard
        }));
const importClientsPage = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ClientsPage/ClientsPage').then((m)=>({
            default: m.ClientsPage
        }));
const importGlobalBillingHub = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/GlobalBillingHub/GlobalBillingHub');
const importAdHocInvoiceApproval = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/AdHocInvoiceApproval/AdHocInvoiceApproval').then((m)=>({
            default: m.AdHocInvoiceApproval
        }));
const importProposalTemplates = ()=>import(/* webpackChunkName: "proposals-config" */ '~/pages/ProposalTemplates/ProposalTemplates').then((m)=>({
            default: m.ProposalTemplates
        }));
const importProposalDefaults = ()=>import(/* webpackChunkName: "proposals-config" */ '~/pages/ProposalDefaults/ProposalDefaults');
const importServicesPage = ()=>import(/* webpackChunkName: "services-library" */ '~/pages/ServicesLibrary/ServicesPage/ServicesPage').then((m)=>({
            default: m.ServicesPage
        }));
const importBundlesPage = ()=>import(/* webpackChunkName: "services-library" */ '~/pages/ServicesLibrary/BundlesPage/BundlesPage').then((m)=>({
            default: m.BundlesPage
        }));
const importAvailableAppsPage = ()=>import(/* webpackChunkName: "integrations" */ '~/integrations/AvailableAppsPage/AvailableAppsPage').then((m)=>({
            default: m.AvailableAppsPage
        }));
const importConnectedAppsPage = ()=>import(/* webpackChunkName: "integrations" */ '~/pages/ConnectedAppsPage/ConnectedAppsPage');
const importAPIKeysPage = ()=>import(/* webpackChunkName: "integrations" */ '~/pages/APIKeysPage/APIKeysPage');
const importProfilePage = ()=>import(/* webpackChunkName: "settings" */ '~/pages/Profile/Profile');
const importBusinessDetails = ()=>import(/* webpackChunkName: "settings" */ '~/pages/BusinessDetails').then((m)=>({
            default: m.BusinessDetails
        }));
const importSalesTaxSettings = ()=>import(/* webpackChunkName: "settings" */ '~/pages/SalesTaxSettings/SalesTaxSettings').then((m)=>({
            default: m.SalesTaxSettings
        }));
const importTeamPage = ()=>import(/* webpackChunkName: "settings" */ '~/pages/TeamPage/TeamPage');
const importAnchorBilling = ()=>import(/* webpackChunkName: "settings" */ '~/pages/AnchorBilling/AnchorBilling');
const importNotificationSettings = ()=>import(/* webpackChunkName: "settings" */ '~/pages/NotificationSettings/NotificationSettings').then((m)=>({
            default: m.NotificationSettings
        }));
const importImportAgreements = ()=>import(/* webpackChunkName: "imports" */ '~/pages/ImportAgreements/ImportAgreements');
const importImportServices = ()=>import(/* webpackChunkName: "imports" */ '~/pages/ImportServices/ImportServices').then((m)=>({
            default: m.ImportServices
        }));
const importImportContacts = ()=>import(/* webpackChunkName: "imports" */ '~/pages/ImportContacts/ImportContacts').then((m)=>({
            default: m.ImportContacts
        }));
const importReports = ()=>import(/* webpackChunkName: "reports" */ '~/pages/Reports/Reports').then((m)=>({
            default: m.Reports
        }));
const importActivityLogsPage = ()=>import(/* webpackChunkName: "reports" */ '~/pages/ActivityLogsPage/ActivityLogsPage');
const importReferralDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ReferralDashboard/ReferralDashboard').then((m)=>({
            default: m.ReferralDashboard
        }));
const importHomePage = ()=>import(/* webpackChunkName: "home" */ '~/pages/HomePage/HomePage').then((m)=>({
            default: m.HomePage
        }));
const CHUNK_LOADERS = {
    home: importHomePage,
    dashboards: importVendorDashboard,
    'proposals-config': importProposalTemplates,
    'services-library': importServicesPage,
    integrations: importAvailableAppsPage,
    settings: importProfilePage,
    reports: importReports,
    'agreement-studio': importAgreementStudioPage,
    'agreement-minisite': importAgreementMinisite
};
export const CHUNK_LOADER_NAMES = new Set(Object.keys(CHUNK_LOADERS));
const ROUTE_CHUNK_LOADERS = ROUTE_CHUNK_ENTRIES.map((param)=>{
    let { chunkName } = param;
    return CHUNK_LOADERS[chunkName];
});
const loadedChunks = new Set();
const chunkLoaderFor = (path)=>{
    const chunkName = routeChunkNameFor(path);
    return chunkName == null ? undefined : CHUNK_LOADERS[chunkName];
};
const loadChunk = (load)=>loadedChunks.has(load) ? Promise.resolve() : load().then(()=>void loadedChunks.add(load));
export function isRouteChunkReady(path) {
    const load = chunkLoaderFor(path);
    return load == null || loadedChunks.has(load);
}
export function preloadRouteChunk(path) {
    const load = chunkLoaderFor(path);
    return load == null ? Promise.resolve() : loadChunk(load);
}
export function isHomeShellChunkReady() {
    return loadedChunks.has(importHomePage);
}
export function preloadBootRouteChunks(path) {
    const chunkNames = bootRouteChunkNames(path);
    const loaders = chunkNames.length > 0 ? chunkNames.map((chunkName)=>CHUNK_LOADERS[chunkName]) : [
        CHUNK_LOADERS[HOME_SHELL_CHUNK],
        CHUNK_LOADERS[DEFAULT_HOME_CONTENT_CHUNK]
    ];
    return Promise.all(loaders.map(loadChunk)).then(()=>undefined);
}
const scheduleIdle = (callback)=>{
    if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(()=>callback(), {
            timeout: 2000
        });
    } else {
        setTimeout(callback, 200);
    }
};
// WHY: one chunk per idle slot, never a mount-time burst — importing everything at once parses all routes back-to-back on the main thread (TBT); sequential idle keeps routes warm (no Suspense flicker on navigation) without competing with interaction.
export function prefetchAllRoutes() {
    const queue = [
        ...ROUTE_CHUNK_LOADERS
    ];
    const next = ()=>{
        const load = queue.shift();
        if (load == null) return;
        void loadChunk(load).finally(()=>scheduleIdle(next));
    };
    scheduleIdle(next);
}
const AllSetPage = lazy(importAllSetPage);
const NoPermissionsRelationshipApproved = lazy(importNoPermissionsRelationshipApproved);
const ClientOnboarding = lazy(importClientOnboarding);
const RelationshipApprovedWithAnimations = lazy(importRelationshipApprovedWithAnimations);
const AgreementStudioPage = lazy(importAgreementStudioPage);
const AgreementStudioTemplates = lazy(importAgreementStudioTemplates);
const CanceledProposalPage = lazy(importCanceledProposalPage);
const EditAgreementPage = lazy(importEditAgreementPage);
const ExpiredProposalPage = lazy(importExpiredProposalPage);
const BankVerification = lazy(importBankVerification);
const AvailableAppsPage = lazy(importAvailableAppsPage);
const ActivityLogsPage = lazy(importActivityLogsPage);
const AdHocInvoiceApproval = lazy(importAdHocInvoiceApproval);
const AgreementMinisite = lazy(importAgreementMinisite);
const AgreementsDashboard = lazy(importAgreementsDashboard);
const AnchorBilling = lazy(importAnchorBilling);
const APIKeysPage = lazy(importAPIKeysPage);
const ArchivedProposalsDashboard = lazy(importArchivedProposalsDashboard);
const BusinessDetails = lazy(importBusinessDetails);
const ClientsPage = lazy(importClientsPage);
const ConnectedAppsPage = lazy(importConnectedAppsPage);
const ContactsDashboard = lazy(importContactsDashboard);
const DraftsDashboard = lazy(importDraftsDashboard);
const GlobalBillingHub = lazy(importGlobalBillingHub);
const HomePage = lazy(importHomePage);
const ImportAgreements = lazy(importImportAgreements);
const ImportContacts = lazy(importImportContacts);
const ImportServices = lazy(importImportServices);
const InvoicesDashboard = lazy(importInvoicesDashboard);
const NotificationSettings = lazy(importNotificationSettings);
const PayoutsDashboard = lazy(importPayoutsDashboard);
const ProfilePage = lazy(importProfilePage);
const ProposalDefaults = lazy(importProposalDefaults);
const ProposalsDashboard = lazy(importProposalsDashboard);
const ProposalTemplateLoader = lazy(importProposalTemplateLoader);
const ProposalTemplates = lazy(importProposalTemplates);
const ReferralDashboard = lazy(importReferralDashboard);
const Reports = lazy(importReports);
const SalesTaxSettings = lazy(importSalesTaxSettings);
const BundlesPage = lazy(importBundlesPage);
const ServicesPage = lazy(importServicesPage);
const TeamPage = lazy(importTeamPage);
const VendorDashboard = lazy(importVendorDashboard);
const VendorOnboardingPage = lazy(importVendorOnboardingPage);
export const unauthorizedPages = [
    {
        url: routes.signUp,
        component: SignupScreen,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.setPassword,
        component: SetPasswordScreen,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.resetPassword,
        component: ResetPasswordScreen,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.notification(),
        component: Notification,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.noPermissionsRelationshipAlreadyApproved,
        component: NoPermissionsRelationshipApproved,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.allSignaturesAcquired(),
        component: RelationshipApprovedWithAnimations,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.expiredProposalPage,
        component: ExpiredProposalPage,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.canceledProposalPage,
        component: CanceledProposalPage,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.additionalPaymentProcessorInfo,
        component: AdditionalPaymentProcessorInfoPage,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.notificationAction,
        component: NotificationActionPage,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.noAccessPage,
        component: NoAccessPage,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.adHocInvoiceApproval(),
        component: AdHocInvoiceApproval,
        supportsMobileViewport: true,
        supportsMobileDevice: true,
        enableIntercom: false
    },
    {
        url: routes.adHocBankVerification(),
        component: BankVerification,
        supportsMobileViewport: true,
        supportsMobileDevice: true,
        enableIntercom: false
    }
];
export const getAuthorizedPages = ()=>{
    const pages = [
        {
            url: routes.redirect,
            component: RedirectPage,
            supportsMobileViewport: true,
            allowPartiallyOnboardedVendor: true,
            enableIntercom: true
        },
        {
            url: routes.home,
            component: HomePage,
            allowPartiallyOnboardedVendor: true,
            enableIntercom: true,
            supportsMobileViewport: false,
            supportsMobileDevice: false
        },
        {
            url: routes.agreementStudio,
            component: AgreementStudioPage,
            vendorOnly: true,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.editAgreement(),
            component: EditAgreementPage,
            vendorOnly: true,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.proposalTemplateStudio,
            component: AgreementStudioTemplates,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.draft(),
            component: AgreementStudioPage,
            vendorOnly: true,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.proposalTemplate(),
            component: ProposalTemplateLoader,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.clientOnboarding(),
            component: ClientOnboarding,
            supportsMobileViewport: true,
            enableIntercom: false
        },
        {
            url: routes.allSet(),
            component: AllSetPage,
            supportsMobileViewport: true,
            enableIntercom: false
        }
    ];
    pages.push({
        url: routes.oauthAuthorize,
        component: OAuthAuthorizePage,
        supportsMobileViewport: true,
        supportsMobileDevice: true,
        enableIntercom: false
    });
    pages.push({
        url: routes.vendorOnboarding,
        component: VendorOnboardingPage,
        allowPartiallyOnboardedVendor: true,
        enableIntercom: false,
        supportsMobileViewport: true,
        supportsMobileDevice: true
    });
    return pages;
};
export function getHomePagePages(featureFlags) {
    const isNotificationsMobileEnabled = featureFlags[FeatureFlag.NOTIFICATION_CONTENT_CUSTOMIZATION] === true;
    const isCrmEnabled = featureFlags[FeatureFlag.FE_CRM] === true;
    const isBillingPageMobileEnabled = featureFlags[FeatureFlag.BILLING_PAGE_MOBILE] === true;
    const isSalesTaxEnabled = featureFlags[FeatureFlag.SALES_TAX] === true;
    const routeConfigs = [
        {
            url: routes.vendorDashboard,
            component: VendorDashboard,
            supportsMobileDevice: true,
            supportsMobileViewport: true,
            enableIntercom: true
        },
        {
            url: routes.agreementsDashboard,
            component: AgreementsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.proposalsDashboard,
            component: ProposalsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.draftsDashboard,
            component: DraftsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.archivedProposals,
            component: ArchivedProposalsDashboard,
            enableIntercom: true
        },
        {
            url: routes.proposalTemplates,
            component: ProposalTemplates,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.proposalDefaults,
            component: ProposalDefaults,
            enableIntercom: true
        },
        {
            url: routes.invoicesDashboard,
            component: InvoicesDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.payoutsDashboard,
            component: PayoutsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.contacts,
            component: ContactsDashboard,
            supportsMobileDevice: true,
            supportsMobileViewport: true,
            enableIntercom: true
        },
        ...isCrmEnabled ? [
            {
                url: routes.clients,
                component: ClientsPage,
                supportsMobileDevice: true,
                supportsMobileViewport: true,
                enableIntercom: true
            }
        ] : [],
        {
            url: routes.serviceLibrary,
            component: ServicesPage,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.bundlesLibrary,
            component: BundlesPage,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.availableApps,
            component: AvailableAppsPage,
            enableIntercom: true
        },
        {
            url: routes.notifications,
            component: NotificationSettings,
            supportsMobileDevice: isNotificationsMobileEnabled,
            supportsMobileViewport: isNotificationsMobileEnabled,
            enableIntercom: true
        },
        {
            url: routes.profile,
            component: ProfilePage,
            supportsMobileDevice: true,
            supportsMobileViewport: true,
            enableIntercom: true
        },
        {
            url: routes.businessDetails,
            component: BusinessDetails,
            enableIntercom: true
        },
        ...isSalesTaxEnabled ? [
            {
                url: routes.salesTax,
                component: SalesTaxSettings,
                enableIntercom: true
            }
        ] : [],
        {
            url: routes.team,
            component: TeamPage,
            enableIntercom: true
        },
        {
            url: routes.anchorBilling,
            component: AnchorBilling,
            enableIntercom: true
        },
        {
            url: routes.importAgreements,
            component: ImportAgreements,
            enableIntercom: true
        },
        {
            url: routes.importServices,
            component: ImportServices,
            enableIntercom: true
        },
        {
            url: routes.importContacts,
            component: ImportContacts,
            enableIntercom: true
        },
        {
            url: routes.minisite(undefined),
            component: AgreementMinisite,
            supportsMobileDevice: isBillingPageMobileEnabled,
            supportsMobileViewport: isBillingPageMobileEnabled,
            enableIntercom: true
        },
        {
            url: routes.globalBillingHub,
            component: GlobalBillingHub,
            supportsMobileDevice: isBillingPageMobileEnabled,
            supportsMobileViewport: isBillingPageMobileEnabled,
            enableIntercom: true
        },
        {
            url: routes.referrals,
            component: ReferralDashboard,
            enableIntercom: true
        },
        {
            url: routes.reports,
            component: Reports,
            enableIntercom: true
        },
        {
            url: routes.anchorApiKeys,
            component: APIKeysPage,
            enableIntercom: true
        },
        {
            url: routes.connectedApps,
            component: ConnectedAppsPage,
            enableIntercom: true
        },
        {
            url: routes.activityLogs,
            component: ActivityLogsPage,
            enableIntercom: true
        }
    ];
    return routeConfigs;
}
